

const Contact=()=>{

    return(

        <h2>THis is contact page</h2>

    )
}

export default Contact;